import { Check, X } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
const comparisonData = [{
  feature: "Code Architectuur",
  template: "Zware & Generieke Code",
  sitecraft: "Lichtgewicht & Maatwerk"
}, {
  feature: "Design Vrijheid",
  template: "Beperkte Templates",
  sitecraft: "Uniek & Pixel-perfect"
}, {
  feature: "Laadsnelheid",
  template: "Trage Gebruikerservaring",
  sitecraft: "Bliksemsnelle Performance"
}, {
  feature: "Schaalbaarheid",
  template: "Star & Beperkend",
  sitecraft: "Gebouwd voor Groei"
}, {
  feature: "Onderhoud",
  template: "Plugin Afhankelijkheid",
  sitecraft: "Veilig & Toekomstbestendig"
}];
export default function TheScratchEdge() {
  return <section data-section-id="129461" id="de-north-websites-standaard" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto space-y-12">
        <div className="space-y-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tighter uppercase font-sans text-foreground">
            De North Websites Standaard
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Ontdek waarom een strategisch ontworpen website van ons bureau superieur is aan standaard templates.
          </p>
        </div>

        <div className="bg-card/30 border border-white/10 shadow-2xl backdrop-blur-xl p-1 md:p-6 overflow-hidden rounded-xl">
          <Table>
            <TableHeader>
              <TableRow className="border-white/10 hover:bg-transparent">
                <TableHead className="w-[30%] text-muted-foreground font-mono uppercase tracking-widest text-xs">
                  Criteria
                </TableHead>
                <TableHead className="w-[35%] text-muted-foreground font-mono uppercase tracking-widest text-xs">
                  Templates
                </TableHead>
                <TableHead className="w-[35%] font-mono uppercase tracking-widest text-xs relative">
                  <div className="flex items-center gap-3">
                    <span className="text-foreground font-bold">North Websites</span>
                    <Badge className="bg-gradient-to-r from-primary to-secondary text-primary-foreground hover:opacity-90 border-none uppercase tracking-widest text-[10px] py-0.5 shadow-lg shadow-primary/20">
                      Superieur
                    </Badge>
                  </div>
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="border-white/5 hover:bg-white/5 transition-colors group">
                  <TableCell className="font-medium text-foreground/90 py-6">
                    {row.feature}
                  </TableCell>
                  <TableCell className="text-muted-foreground py-6">
                    <div className="flex items-center gap-2">
                      <X className="size-4 text-muted-foreground/40 shrink-0" />
                      <span className="text-sm">{row.template}</span>
                    </div>
                  </TableCell>
                  <TableCell className="py-6 bg-primary/5">
                    <div className="flex items-center gap-2">
                      <Check className="size-5 text-primary shrink-0 drop-shadow-[0_0_10px_rgba(139,92,246,0.6)]" />
                      <span className="text-foreground font-bold tracking-tight text-sm">
                        {row.sitecraft}
                      </span>
                    </div>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}